<template>
   <v-dialog v-model="showModal"
    persistent
    content-class="escalon-dialog">
    <v-card>
      <v-toolbar class="escalon-dialog-header primary" height="35">
        <img
          class="modal-axis-logo mr-2"
          :src="require('../../assets/' + coloredLogo)" />
        <span><slot name="header"></slot></span>
        <v-spacer/>
        <close-button @click="$emit('modalCancel')"/>
      </v-toolbar>
      <v-card-text class="escalon-dialog-content">
        <slot></slot>
      </v-card-text>
      <v-card-actions>     
        <v-spacer/>
        <v-btn text @click="$emit('modalConfirm')" class="modal-cta">Confirm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import closeButton from "../controls/CloseButton";
export default {
  name: "escalonDialog",
  components: { closeButton },
  props: {
    showModal: Boolean
  }
};
</script>